import React from 'react';
import { motion } from 'framer-motion';
import { HomeIcon, ScaleIcon, MapIcon, PhoneIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
const navItems = [{
  path: '/',
  icon: HomeIcon,
  label: 'Home'
}, {
  path: '/laws',
  icon: ScaleIcon,
  label: 'Laws'
}, {
  path: '/rides',
  icon: MapIcon,
  label: 'Rides'
}, {
  path: '/contact',
  icon: PhoneIcon,
  label: 'Contact'
}];
export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const getActiveIndex = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path.includes('law') || path.includes('cops') || path.includes('crash') || path.includes('helmet') || path.includes('gun') || path.includes('insurance')) return 1;
    if (path.includes('ride') || path.includes('bars')) return 2;
    if (path.includes('contact')) return 3;
    return 0;
  };
  const activeIndex = getActiveIndex();
  return <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-lg border-t border-[#2a2a2a]" data-id="element-41">
      <div className="max-w-md mx-auto px-2 pb-[env(safe-area-inset-bottom)]" data-id="element-42">
        <div className="relative flex items-center justify-around h-16" data-id="element-43">
          {/* Animated indicator */}
          <motion.div className="absolute top-0 h-0.5 w-12 bg-[#d4a853] rounded-full" initial={false} animate={{
          left: `calc(${activeIndex * 25}% + 12.5% - 24px)`
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 30
        }} data-id="element-44" />

          {navItems.map((item, index) => {
          const isActive = activeIndex === index;
          const Icon = item.icon;
          return <button key={item.path} onClick={() => navigate(item.path)} className="flex flex-col items-center justify-center w-16 h-full" aria-label={item.label} data-id="element-45">
                <Icon className={`w-6 h-6 transition-colors duration-200 ${isActive ? 'text-[#d4a853]' : 'text-[#a3a3a3]'}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-46" />
                <span className={`text-[10px] mt-1 font-medium transition-colors duration-200 ${isActive ? 'text-[#d4a853]' : 'text-[#a3a3a3]'}`} data-id="element-47">
                  {item.label}
                </span>
              </button>;
        })}
        </div>
      </div>
    </nav>;
}